module.exports = __webpack_public_path__ + "img/cs-protrain-3.dec0860a.jpg";